/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ErrorResponse,
  MusicVideoClip,
  MusicVideoCompose202,
  MusicVideoCreateRequest,
  MusicVideoDetail,
  MusicVideoGenerateClips202,
  MusicVideoGenerateSceneClip202,
  MusicVideoGenerateScenes202,
  MusicVideoListParams,
  MusicVideoScene,
  PaginatedMusicVideoListList,
  PatchedMusicVideoSceneUpdateRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 현재 사용자의 뮤직비디오 목록을 조회합니다.
 * @summary 뮤직비디오 목록 조회
 */
export const musicVideoList = (
  params?: MusicVideoListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedMusicVideoListList>(
    { url: `/api/music-videos/`, method: "GET", params, signal },
    options,
  );
};

export const getMusicVideoListQueryKey = (params?: MusicVideoListParams) => {
  return [`/api/music-videos/`, ...(params ? [params] : [])] as const;
};

export const getMusicVideoListQueryOptions = <
  TData = Awaited<ReturnType<typeof musicVideoList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: MusicVideoListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof musicVideoList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMusicVideoListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof musicVideoList>>> = ({
    signal,
  }) => musicVideoList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof musicVideoList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MusicVideoListQueryResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoList>>
>;
export type MusicVideoListQueryError = ErrorType<ErrorResponse>;

export function useMusicVideoList<
  TData = Awaited<ReturnType<typeof musicVideoList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | MusicVideoListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof musicVideoList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof musicVideoList>>,
          TError,
          Awaited<ReturnType<typeof musicVideoList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMusicVideoList<
  TData = Awaited<ReturnType<typeof musicVideoList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: MusicVideoListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof musicVideoList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof musicVideoList>>,
          TError,
          Awaited<ReturnType<typeof musicVideoList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMusicVideoList<
  TData = Awaited<ReturnType<typeof musicVideoList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: MusicVideoListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof musicVideoList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 뮤직비디오 목록 조회
 */

export function useMusicVideoList<
  TData = Awaited<ReturnType<typeof musicVideoList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: MusicVideoListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof musicVideoList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getMusicVideoListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 새 뮤직비디오를 생성합니다. TrackVersion을 소스로 지정합니다.
 * @summary 뮤직비디오 생성
 */
export const musicVideoCreate = (
  musicVideoCreateRequest: BodyType<MusicVideoCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoDetail>(
    {
      url: `/api/music-videos/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: musicVideoCreateRequest,
      signal,
    },
    options,
  );
};

export const getMusicVideoCreateMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoCreate>>,
    TError,
    { data: BodyType<MusicVideoCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoCreate>>,
  TError,
  { data: BodyType<MusicVideoCreateRequest> },
  TContext
> => {
  const mutationKey = ["musicVideoCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoCreate>>,
    { data: BodyType<MusicVideoCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return musicVideoCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoCreate>>
>;
export type MusicVideoCreateMutationBody = BodyType<MusicVideoCreateRequest>;
export type MusicVideoCreateMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 뮤직비디오 생성
 */
export const useMusicVideoCreate = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoCreate>>,
      TError,
      { data: BodyType<MusicVideoCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoCreate>>,
  TError,
  { data: BodyType<MusicVideoCreateRequest> },
  TContext
> => {
  const mutationOptions = getMusicVideoCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 뮤직비디오 상세 정보를 씬 및 클립과 함께 조회합니다.
 * @summary 뮤직비디오 상세 조회
 */
export const musicVideoRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoDetail>(
    { url: `/api/music-videos/${id}/`, method: "GET", signal },
    options,
  );
};

export const getMusicVideoRetrieveQueryKey = (id?: string) => {
  return [`/api/music-videos/${id}/`] as const;
};

export const getMusicVideoRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof musicVideoRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof musicVideoRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMusicVideoRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof musicVideoRetrieve>>
  > = ({ signal }) => musicVideoRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof musicVideoRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MusicVideoRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoRetrieve>>
>;
export type MusicVideoRetrieveQueryError = ErrorType<
  ErrorResponse | ErrorResponse
>;

export function useMusicVideoRetrieve<
  TData = Awaited<ReturnType<typeof musicVideoRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof musicVideoRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof musicVideoRetrieve>>,
          TError,
          Awaited<ReturnType<typeof musicVideoRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMusicVideoRetrieve<
  TData = Awaited<ReturnType<typeof musicVideoRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof musicVideoRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof musicVideoRetrieve>>,
          TError,
          Awaited<ReturnType<typeof musicVideoRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMusicVideoRetrieve<
  TData = Awaited<ReturnType<typeof musicVideoRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof musicVideoRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 뮤직비디오 상세 조회
 */

export function useMusicVideoRetrieve<
  TData = Awaited<ReturnType<typeof musicVideoRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof musicVideoRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getMusicVideoRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 뮤직비디오를 삭제합니다.
 * @summary 뮤직비디오 삭제
 */
export const musicVideoDelete = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/music-videos/${id}/`, method: "DELETE" },
    options,
  );
};

export const getMusicVideoDeleteMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoDelete>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoDelete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["musicVideoDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoDelete>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return musicVideoDelete(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoDelete>>
>;

export type MusicVideoDeleteMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 뮤직비디오 삭제
 */
export const useMusicVideoDelete = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoDelete>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoDelete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMusicVideoDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 선택된 클립들을 하나의 뮤직비디오로 합성합니다.
 * @summary 뮤직비디오 합성
 */
export const musicVideoCompose = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoCompose202>(
    { url: `/api/music-videos/${id}/compose/`, method: "POST", signal },
    options,
  );
};

export const getMusicVideoComposeMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoCompose>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoCompose>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["musicVideoCompose"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoCompose>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return musicVideoCompose(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoComposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoCompose>>
>;

export type MusicVideoComposeMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 뮤직비디오 합성
 */
export const useMusicVideoCompose = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoCompose>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoCompose>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMusicVideoComposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 모든 씬에 대해 Kling AI 비디오 클립 생성을 시작합니다.
 * @summary 전체 클립 생성 (Kling)
 */
export const musicVideoGenerateClips = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoGenerateClips202>(
    { url: `/api/music-videos/${id}/generate-clips/`, method: "POST", signal },
    options,
  );
};

export const getMusicVideoGenerateClipsMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoGenerateClips>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoGenerateClips>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["musicVideoGenerateClips"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoGenerateClips>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return musicVideoGenerateClips(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoGenerateClipsMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoGenerateClips>>
>;

export type MusicVideoGenerateClipsMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 전체 클립 생성 (Kling)
 */
export const useMusicVideoGenerateClips = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoGenerateClips>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoGenerateClips>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMusicVideoGenerateClipsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Claude AI를 사용하여 뮤직비디오의 씬별 비주얼 프롬프트를 생성합니다.
 * @summary 씬 프롬프트 생성 (Claude)
 */
export const musicVideoGenerateScenes = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoGenerateScenes202>(
    { url: `/api/music-videos/${id}/generate-scenes/`, method: "POST", signal },
    options,
  );
};

export const getMusicVideoGenerateScenesMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoGenerateScenes>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoGenerateScenes>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["musicVideoGenerateScenes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoGenerateScenes>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return musicVideoGenerateScenes(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoGenerateScenesMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoGenerateScenes>>
>;

export type MusicVideoGenerateScenesMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 씬 프롬프트 생성 (Claude)
 */
export const useMusicVideoGenerateScenes = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoGenerateScenes>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoGenerateScenes>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMusicVideoGenerateScenesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 씬의 프롬프트, 참조 이미지, 분위기, 카메라 움직임을 수정합니다.
 * @summary 씬 프롬프트 수정
 */
export const musicVideoUpdateScene = (
  id: string,
  sceneId: string,
  patchedMusicVideoSceneUpdateRequest: BodyType<PatchedMusicVideoSceneUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<MusicVideoScene>(
    {
      url: `/api/music-videos/${id}/scenes/${sceneId}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedMusicVideoSceneUpdateRequest,
    },
    options,
  );
};

export const getMusicVideoUpdateSceneMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoUpdateScene>>,
    TError,
    {
      id: string;
      sceneId: string;
      data: BodyType<PatchedMusicVideoSceneUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoUpdateScene>>,
  TError,
  {
    id: string;
    sceneId: string;
    data: BodyType<PatchedMusicVideoSceneUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ["musicVideoUpdateScene"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoUpdateScene>>,
    {
      id: string;
      sceneId: string;
      data: BodyType<PatchedMusicVideoSceneUpdateRequest>;
    }
  > = (props) => {
    const { id, sceneId, data } = props ?? {};

    return musicVideoUpdateScene(id, sceneId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoUpdateSceneMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoUpdateScene>>
>;
export type MusicVideoUpdateSceneMutationBody =
  BodyType<PatchedMusicVideoSceneUpdateRequest>;
export type MusicVideoUpdateSceneMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 씬 프롬프트 수정
 */
export const useMusicVideoUpdateScene = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoUpdateScene>>,
      TError,
      {
        id: string;
        sceneId: string;
        data: BodyType<PatchedMusicVideoSceneUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoUpdateScene>>,
  TError,
  {
    id: string;
    sceneId: string;
    data: BodyType<PatchedMusicVideoSceneUpdateRequest>;
  },
  TContext
> => {
  const mutationOptions = getMusicVideoUpdateSceneMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 씬에서 최종 합성에 사용할 클립을 선택합니다.
 * @summary 클립 선택
 */
export const musicVideoSelectClip = (
  id: string,
  sceneId: string,
  clipId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoClip>(
    {
      url: `/api/music-videos/${id}/scenes/${sceneId}/clips/${clipId}/select/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getMusicVideoSelectClipMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoSelectClip>>,
    TError,
    { id: string; sceneId: string; clipId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoSelectClip>>,
  TError,
  { id: string; sceneId: string; clipId: string },
  TContext
> => {
  const mutationKey = ["musicVideoSelectClip"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoSelectClip>>,
    { id: string; sceneId: string; clipId: string }
  > = (props) => {
    const { id, sceneId, clipId } = props ?? {};

    return musicVideoSelectClip(id, sceneId, clipId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoSelectClipMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoSelectClip>>
>;

export type MusicVideoSelectClipMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 클립 선택
 */
export const useMusicVideoSelectClip = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoSelectClip>>,
      TError,
      { id: string; sceneId: string; clipId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoSelectClip>>,
  TError,
  { id: string; sceneId: string; clipId: string },
  TContext
> => {
  const mutationOptions = getMusicVideoSelectClipMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 씬에 대한 Kling AI 비디오 클립을 재생성합니다.
 * @summary 개별 씬 클립 재생성
 */
export const musicVideoGenerateSceneClip = (
  id: string,
  sceneId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MusicVideoGenerateSceneClip202>(
    {
      url: `/api/music-videos/${id}/scenes/${sceneId}/generate-clip/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getMusicVideoGenerateSceneClipMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof musicVideoGenerateSceneClip>>,
    TError,
    { id: string; sceneId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof musicVideoGenerateSceneClip>>,
  TError,
  { id: string; sceneId: string },
  TContext
> => {
  const mutationKey = ["musicVideoGenerateSceneClip"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof musicVideoGenerateSceneClip>>,
    { id: string; sceneId: string }
  > = (props) => {
    const { id, sceneId } = props ?? {};

    return musicVideoGenerateSceneClip(id, sceneId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MusicVideoGenerateSceneClipMutationResult = NonNullable<
  Awaited<ReturnType<typeof musicVideoGenerateSceneClip>>
>;

export type MusicVideoGenerateSceneClipMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 개별 씬 클립 재생성
 */
export const useMusicVideoGenerateSceneClip = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof musicVideoGenerateSceneClip>>,
      TError,
      { id: string; sceneId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof musicVideoGenerateSceneClip>>,
  TError,
  { id: string; sceneId: string },
  TContext
> => {
  const mutationOptions =
    getMusicVideoGenerateSceneClipMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
